<template>
  <v-container
    fill-height
    fluid
    grid-list-xl
  >
    <v-layout
      justify-center
      wrap
    >
      <v-flex
        md12
      >

 <v-spacer></v-spacer>

      <!-- <v-flex xs12> -->
        <material-card
            :color="app.color">    
            <v-layout row   slot="header">
              <v-flex xs6>
                <span class="title">Settings</span> <br>
                <span class="body-1">Settings van {{user.organisation.name}}</span>
              </v-flex>

            </v-layout>

            <v-tabs 
              v-model="tab"
              :slider-color="app.color">
              <v-tab>{{user.organisation.name}}</v-tab>
              <!-- <v-tab>Tekenbevoegd</v-tab> -->
              <v-tab>Email</v-tab>
              <!-- <v-tab>Organisaties</v-tab> -->
              <!-- <v-tab>Users</v-tab> -->


              <v-tab v-if="user.authorization == 'superuser'">Object types</v-tab>
              <v-tab v-if="user.authorization == 'superuser'">Templates</v-tab>
              <v-tab v-if="user.authorization == 'superuser'">Organisation types</v-tab>
            </v-tabs>


            <v-tabs-items v-model="tab">
              <!-- section for the default preferences -->

              <v-tab-item>
                <settings-preferences target="general"></settings-preferences>
              </v-tab-item>

              <v-tab-item>
                <settings-preferences target="email"></settings-preferences>
              </v-tab-item>

              <!-- // <v-tab-item>
              //   <settings-organisations></settings-organisations>
              // </v-tab-item> -->

              <v-tab-item>
                <v-container fluid="">
                  <v-layout class="pa-0">
                    <v-flex xs6 class="pa-0">

                  <v-layout justify-end="" >
                    <v-tooltip left dark>
                        <template #activator='data'>
                            <v-icon medium="" @click="settings.newObject.show = true"  color="success" v-on="data.on">mdi-plus</v-icon>
                        </template>
                        <span>Object toevoegen</span>
                    </v-tooltip>                      
                  </v-layout>

                  <v-data-table
                    :headers="objectHeaders"
                    :items="types"
                  >

                    <template v-slot:item.description="props">
                      <v-edit-dialog
                        :return-value.sync="props.item.description"
                        @save="save"
                        @cancel="cancel"
                        @open="open"
                        @close="close"
                      > {{ props.item.description }}
                        <template v-slot:input>
                          <v-text-field
                            v-model="props.item.description"
                            :rules="[max25chars]"
                            label="Edit"
                            single-line
                            counter
                          ></v-text-field>
                        </template>
                      </v-edit-dialog>
                    </template>

                    <template
                      slot="headerCell"
                      slot-scope="{ header }"
                    >
                      <span
                        class="subheading font-weight-light text-success text--darken-3"
                        v-text="header.text"
                      />
                    </template>

                    <template
                      v-slot:item="obs"
                    >
                    <tr @click="getType(obs.item.reference)">
                      <td>{{obs.item.description}}</td>                
                      <td>{{obs.item.code}}</td>
                      <td>{{obs.item.icon}}</td>
                    </tr>
                  </template>
                  </v-data-table>    
                  </v-flex>
                  <!-- </v-layout> -->

                <!-- </v-container> -->

                <v-expand-transition>

                      <v-flex xs5 offset-xs1 v-if="settings.type !== null">
                        <v-text-field v-model="type.description" @input="changeType()" label="Naam">Naam</v-text-field>
                        <!-- <v-text-field v-model="type.code" @input="changeType()" label="Code">Code</v-text-field> -->
                        <v-checkbox v-model="type.is_person"  @change="changeType()" label="Is person"></v-checkbox>
                        <v-checkbox v-model="type.is_company" @change="changeType()" label="Is Company"></v-checkbox>
                        <v-checkbox v-model="type.is_estate"  @change="changeType()" label="Is Estate"></v-checkbox>
                        <v-checkbox v-model="type.is_object"  @change="changeType()" label="is Object"></v-checkbox>
                        <!-- <v-checkbox v-model="type.crm" @change="changeType()" label="CRM">CRM</v-checkbox>
                        <v-checkbox v-model="type.managed" @change="changeType()" label="Managed">Managed</v-checkbox>  -->
                        <!-- <v-text-field v-model="type.icon" @input="changeType()" label="Icon">Icon</v-text-field>                                            -->
                    <v-layout justify-end="" style="min-height:78px;">
                      <v-flex md6 xs6>
                        <v-slide-x-transition>
                          <v-btn rounded="" block="" v-if="app.settings.change" @click="resetType()" color="warning">Reset</v-btn>
                        </v-slide-x-transition>
                      </v-flex>
                      <v-flex md6 xs6>
                        <v-slide-x-transition>
                          <v-btn rounded="" block="" v-if="app.settings.change" @click="updateType()" color="success">Opslaan</v-btn>
                        </v-slide-x-transition>
                      </v-flex>
                    </v-layout>
                      </v-flex>                                         
                    </v-expand-transition>
                  </v-layout>                    
                </v-container>

                <settings-object-fields></settings-object-fields>

                <settings-object-headers></settings-object-headers>



              </v-tab-item>

              <v-tab-item>
                <v-container fluid>
                  <v-layout class="pa-0">
                    <v-flex class="pa-0">
                  <v-layout justify-end="" >
                    <v-tooltip left dark>
                        <template #activator='data'>
                            <v-icon medium="" @click="settings.newTemplate.show = true"  color="success" v-on="data.on">mdi-plus</v-icon>
                        </template>
                        <span>Model toevoegen</span>
                    </v-tooltip>     
                  
                  </v-layout>


                  <v-data-table
                    :headers="templateHeaders"
                    :items="settings.templates"
                    hide-default-footer
                  >

                    <template
                      slot="headerCell"
                      slot-scope="{ header }"
                    >
                      <span
                        class="subheading font-weight-light text-success text--darken-3"
                        v-text="header.text"
                      />
                    </template>
                    <template
                      v-slot:item="props"
                    >
                    <tr @click="getTemplate(props.item.reference)">
                      <td>{{props.item.parent_name}}</td>                
                      <td>{{props.item.name}}<v-icon small color="warning" v-if="!props.item.generic">mdi-alert</v-icon></td>
                      <td>{{props.item.subtitle}}</td>
                      <td>{{props.item.owner}}</td>
                      <td>{{props.item.party_1_name}}</td>
                      <td>{{props.item.party_2_name}}</td>
                      <td>{{props.item.party_3_name}}</td>
                      <td>{{props.item.party_4_name}}</td>
                      <td>{{props.item.party_5_name}}</td>
                      <td>{{props.item.party_6_name}}</td>
                    </tr>
                    </template>
                  </v-data-table>    
                  </v-flex>
                  </v-layout>
                </v-container>        

                <v-expand-transition>
                  <v-container fluid v-if="settings.template !== null">
                    <v-layout wrap>
                      <v-flex md4 xs12>
                        <v-layout row class="pa-1">
                          <p class="subheading text-success pa-1">Details</p>
                        </v-layout>
                        <v-layout row class="pa-1">
                          <v-text-field class="pa-1" @change="change()" v-model="settings.template.name" label="Naam"></v-text-field>
                        </v-layout>
                        <v-layout row class="pa-1">
                          <v-text-field class="pa-1" @change="change()" v-model="settings.template.subtitle" label="Subtitle"></v-text-field>
                        </v-layout>
                        <v-layout row class="pa-1">
                          <v-text-field class="pa-1" @change="change()" v-model="settings.template.owner" label="Organisatie"></v-text-field>
                        </v-layout>
                        <v-layout row class="pa-1">
                          <v-text-field class="pa-1" @change="change()" v-model="settings.template.version" label="Versie"></v-text-field>
                        </v-layout>
                        <v-layout row class="pa-1">
                          <v-text-field class="pa-1" @change="change()" v-model="settings.template.editor" label="Beheerder"></v-text-field>
                        </v-layout>
                        <v-layout row class="pa-1">
                          <v-text-field class="pa-1" @change="change()" v-model="settings.template.title" label="Model"></v-text-field>
                        </v-layout>                                                                                          
                      </v-flex>

                      <v-flex md8 xs12>
                        <v-layout row class="pa-1">
                          <p class="subheading text-success pa-1">Partijen</p>
                        </v-layout>                  
                        <v-layout row class="pa-1">
                            <v-text-field class="pa-1" @input="change()" v-model="settings.template.parent_name" label="Object"></v-text-field>                    
                            <v-autocomplete 
                            style="max-width:450px; min-width:450px;"
                            clearable
                            dense 
                            :items="types"
                            item-text="description"
                            item-value="reference"
                            v-model="settings.template.parent"
                            @change="change()"
                            class="pa-1" label="Parent Object"></v-autocomplete>                  
                        </v-layout>
                        <v-layout row class="pa-1">
                            <v-text-field class="pa-1" @change="change()" v-model="settings.template.party_1_name" label="Partij 1"></v-text-field>                    
                            <v-autocomplete 
                            style="max-width:450px; min-width:450px;"
                            clearable
                            multiple
                            dense 
                            :items="types"
                            item-text="description"
                            item-value="reference"
                            v-model="settings.template.party_1"
                            @change="change()"
                            class="pa-1" label="Object"></v-autocomplete>                
                        </v-layout>
                        <v-layout row class="pa-1">
                            <v-text-field class="pa-1" @change="change()" v-model="settings.template.party_2_name" label="Partij 2"></v-text-field>                    
                            <v-autocomplete 
                            style="max-width:450px; min-width:450px;"
                            clearable
                            multiple                       
                            dense 
                            :items="types"
                            item-text="description"
                            item-value="reference"
                            v-model="settings.template.party_2"
                            @change="change()"
                            class="pa-1" label="Object"></v-autocomplete>                
                        </v-layout>
                        <v-layout row class="pa-1">
                            <v-text-field class="pa-1" @change="change()" v-model="settings.template.party_3_name" label="Partij 3"></v-text-field>                    
                            <v-autocomplete 
                            style="max-width:450px; min-width:450px;"
                            clearable
                            multiple
                            dense 
                            :items="types"
                            item-text="description"
                            item-value="reference"
                            v-model="settings.template.party_3"
                            @change="change()"
                            class="pa-1" label="Object"></v-autocomplete>                
                        </v-layout>
                        <v-layout row class="pa-1">
                            <v-text-field class="pa-1" @change="change()" v-model="settings.template.party_4_name" label="Partij 4"></v-text-field>                    
                            <v-autocomplete 
                            style="max-width:450px; min-width:450px;"
                            clearable
                            multiple
                            dense 
                            :items="types"
                            item-text="description"
                            item-value="reference"
                            v-model="settings.template.party_4"
                            @change="change()"
                            class="pa-1" label="Object"></v-autocomplete>                
                        </v-layout>
                        <v-layout row class="pa-1">
                            <v-text-field class="pa-1" @change="change()" v-model="settings.template.party_5_name" label="Partij 5"></v-text-field>                    
                            <v-autocomplete 
                            style="max-width:450px; min-width:450px;"
                            clearable
                            multiple
                            dense 
                            :items="types"
                            item-text="description"
                            item-value="reference"
                            v-model="settings.template.party_5"
                            @change="change()"
                            class="pa-1" label="Object"></v-autocomplete>                
                        </v-layout>                                                                        
                        <v-layout row class="pa-1">
                            <v-text-field class="pa-1" @change="change()" v-model="settings.template.party_6_name" label="Partij 6"></v-text-field>                    
                            <v-autocomplete 
                            style="max-width:450px; min-width:450px;"
                            clearable
                            multiple
                            dense 
                            :items="types"
                            item-text="description"
                            item-value="reference"
                            v-model="settings.template.party_6"
                            @change="change()"
                            class="pa-1" label="Object"></v-autocomplete>                
                        </v-layout>                  
                      </v-flex>
                    </v-layout>
                    <v-layout justify-end="" style="min-height:78px;">
                      <v-flex md2 xs6>
                          <v-slide-x-transition>
                              <v-btn rounded="" block="" v-if="hasChange" @click="resetTemplate()" color="warning">Reset</v-btn>
                          </v-slide-x-transition>
                      </v-flex>
                      <v-flex md2 xs6>
                          <v-slide-x-transition>
                              <v-btn rounded="" block="" v-if="hasChange" @click="updateTemplate()" color="success">Opslaan</v-btn>
                          </v-slide-x-transition>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-expand-transition> 

               </v-tab-item>

               <v-tab-item>
                 <settings-organisation-types></settings-organisation-types>
               </v-tab-item>


            </v-tabs-items>                

            <v-dialog 
              v-model="settings.newTemplate.show"
              width="500">
              <material-card>
                <v-form v-model="settings.newTemplate.valid">
                  <v-text-field class="pa-1" :rules="settings.newTemplate.nameRules" required v-model="settings.newTemplate.template.name" label="Naam"></v-text-field>
                  <v-autocomplete 
                    :rules="settings.newTemplate.nameRules"
                    required
                    clearable
                    dense 
                    :items="types"
                    item-text="description"
                    item-value="reference"
                    v-model="settings.newTemplate.template.parent"
                    @change="change()"
                    class="pa-1" label="Parent Object"></v-autocomplete>  
                  <v-layout justify-end="" style="min-height:54px;">
                    <v-slide-x-transition>
                      <v-btn rounded color="success" v-if="settings.newTemplate.valid" @click="createTemplate()" >template aanmaken</v-btn>
                    </v-slide-x-transition>
                  </v-layout>                        
                </v-form>
              </material-card>
            </v-dialog>

            <v-dialog 
              v-model="settings.newObject.show"
              width="500">
              <material-card>
                <v-form v-model="settings.newObject.valid">
                  <v-text-field class="pa-1" :rules="settings.newObject.nameRules" required v-model="settings.newObject.type.name" label="Naam"></v-text-field>
                  <v-text-field class="pa-1" :rules="settings.newObject.nameRules" required v-model="settings.newObject.type.code" label="Code"></v-text-field>
                  <v-layout justify-end="" style="min-height:54px;">
                    <v-slide-x-transition>
                      <v-btn rounded color="success" v-if="settings.newObject.valid" @click="createType()" >object type aanmaken</v-btn>
                    </v-slide-x-transition>
                  </v-layout>                        
                </v-form>
              </material-card>
            </v-dialog>

            <v-slide-x-transition>
            <v-dialog 
              v-model="settings.deleteObject"
              width="500">
              <material-card>
                <p class="text-center">Wilt u het object {{type.description}} definitief verwijderen?</p>
                <v-layout justify-center="">
                  <v-btn rounded color="error" @click="deleteType()" >verwijderen</v-btn>
                </v-layout>
              </material-card>
            </v-dialog>
            </v-slide-x-transition>
        </material-card>
        </v-flex>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapState } from "vuex";

export default {
  data: () => ({
    active: null,
    tab: null,
    selected: [],
    templateHeaders: [
      { text: "Parent", value: "parent.description", sortable: true },
      { text: "Naam", value: "name", sortable: true },
      { text: "Subtitle", value: "subtitle", sortable: true },
      { text: "Owner", value: "owner", sortable: false },
      { text: "Party 1", value: "party_1_name", sortable: false },
      { text: "Party 2", value: "party_2_name", sortable: false },
      { text: "Party 3", value: "party_3_name", sortable: false },
      { text: "Party 4", value: "party_4_name", sortable: false },
      { text: "Party 5", value: "party_5_name", sortable: false },
      { text: "Party 6", value: "party_6_name", sortable: false }
    ],
    objectHeaders: [
      { text: "Naam", value: "description", sortable: true },
      { text: "Code", value: "code", sortable: true },
      { text: "Icon", value: "icon", sortable: false }
    ]
  }),
  computed: {
    ...mapState(["app", "user", "settings", "types", "type"])
  },
  methods: {
    hasChange() {
      this.hasChange = true;
    },
    resetTemplate() {
      this.$store.dispatch("settingsGetTemplate", {
        reference: this.$store.state.settings.template.reference
      });
      this.hasChange = false;
    },
    updateTemplate() {
      this.hasChange = false;
      this.$store.dispatch("updateTemplate");
    },
    createTemplate() {
      this.$store.dispatch(
        "createTemplate",
        this.settings.newTemplate.template
      );
    },
    toObject(a) {
      this.$router.push("/object");
    },
    change() {
      if (!this.hasChange) {
        this.hasChange = true;
      }
    },
    changeType() {
      this.app.settings.change = true;
    },
    getTemplate(reference) {
      this.hasChange = false;
      this.$store.dispatch("settingsGetTemplate", {
        reference: reference
      });
    },
    getType(reference) {
      this.app.settings.change = false;
      this.$store.dispatch("getType", {
        reference: reference
      });
    },
    resetType() {
      this.app.settings.change = false;
      this.$store.dispatch("getType", {
        reference: this.$store.state.type.reference
      });
    },
    updateType() {
      this.app.settings.change = false;
      this.$store.dispatch("updateType");
    },
    createType() {
      this.$store.dispatch(
        "createType",
        this.$store.state.settings.newObject.type
      );
    },
    deleteType() {
      this.$store.dispatch("deleteType");
    }
  },
  created() {
    this.$store.dispatch("checkAuth");
    this.$store.dispatch("settingsGetTemplates");
    this.$store.dispatch("organisations/getTypes");
    this.$store.dispatch("user/fetchUser");
  },
  createObjectType() {}
};
</script>

<style scoped>
.selectorRow {
  background-color: rgb(116, 136, 116) !important;
}
</style>

